/**
 * @ngdoc Controller
 */

import 'slick-carousel';

(function() {
    'use strict';

    angular.module('vrm.components')
        .controller('CarouselController', CarouselController);


    /* @ngInject */
    function CarouselController($scope, $timeout, installation, close, VrmModalService, ApiService, vrmNotificationsService, vrmNotificationType, locale, $q, $log) {
        $scope.images = installation && installation.images ? installation.images : [];
        $scope.index = 0;
        $scope.initialImages = $scope.images.slice(0);
        $scope.loading = true;
        return {
            open: function () {
                var _this = this;
                var slickSettings = {
                    adaptiveHeight: true,
                    prevArrow: '.vrm-carousel__items-wrap__control--previous',
                    nextArrow: '.vrm-carousel__items-wrap__control--next',
                    useTransform: true,
                    cssEase: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
                    respondTo: 'min'
                };
                $timeout(function() {
                    var element = _this.content.find('.vrm-carousel__items-wrap__items');
                    //Show all images before initializing carousel
                    element.children().removeClass('ng-hide');
                    var carousel = element.slick(slickSettings).slick('getSlick');
                    element.slick('setPosition');
                    element.on('afterChange', function () {
                        $scope.index = carousel.currentSlide;
                        $scope.$digest();
                    });

                    $scope.$on('$destroy', function() {
                        element.slick('unslick');
                    });

                    $scope.addPhoto = function() {
                        VrmModalService.next(function(scope) {
                            VrmModalService.openUploadModal(scope, 'photo', async function(files) {
                                vrmNotificationsService.add({
                                    type: vrmNotificationType.INFO,
                                    message: locale.getString('dashboard.photo_uploading')
                                });
                                for (var i = 0; i < files.length; i++) {
                                    var data = new FormData();
                                    data.append('data',files[i]);
                                    try {
                                        const response = await ApiService.installationUploadPhoto(installation.idSite, data);
                                        if (!installation.images) {
                                            installation.images = [];
                                        }
                                        installation.images.push(response.data);
                                    } catch (error) {
                                        $log.error("Error uploading photo", error);
                                    }
                                }
                                //Reopen carousel after photo upload
                                VrmModalService.openCarouselModal(scope, installation);
                            });
                        });
                        $.magnificPopup.close();
                    };

                    $scope.removePhoto = function() {
                        ApiService.call('/installations/' + installation.idSite + '/photo-delete?idSiteImage=' + $scope.images[$scope.index].idSiteImage, {}).then(function() {
                            element.slick('slickRemove', $scope.index);
                            installation.images.splice($scope.index, 1);
                            if (installation.images.length == 0)
                            {
                                element.slick('unslick');
                            }
                            if ($scope.index >= $scope.images.length) {
                                $scope.index--;
                            }
                        });
                    };
                }, 500);
            },
            close: close
        }
    }

})();
